import { IRegion } from './region.interface';

export type IOrganizationCreatedAt = string;
export type IOrganizationId = null | number;
export type IOrganizationName = string;
export type IOrganizationWeightUnit = string;
export type IOrganizationDistanceUnit = string;
export type IOrganizationTemperatureUnit = string;
export type ICountry = string;
export type IOrganizationUpdatedAt = string;
export type IOrganizationLogoBanner = string;
export type IOrganizationLogoIcon = string;
export type IOrganizationVideoID = string;
export type IOrganizationColour = string;
export type IOrganizationRegionCount = null | number;
export type IOrganizationUserCount = null | number;
export type IOrganizationWaiver = string;
export type IOrganizationDriverHelp = string;
export type IOrganizationPrograms = {
    id: number;
    organization_id: number;
    name: string;
    hidden_donor: boolean;
    hidden_recipient: boolean;
}[];
export type IShowRouteWidgetFeed = boolean;
export type IEmbeddableDomain = string;
export type INotificationSetting = boolean;
export type IApprovalRequired = boolean;
export type IFeatureEnabled = boolean;
export type IDeliveryDriverCanChangeFoodProducts = boolean;
export type IDeliveryDriverCanSetWeight = boolean;

export interface IOrganization {
    created_at: IOrganizationCreatedAt
    id: IOrganizationId;
    name: IOrganizationName;
    weight_unit: IOrganizationWeightUnit;
    distance_unit: IOrganizationDistanceUnit;
    temperature_unit: IOrganizationTemperatureUnit;
    country: ICountry;
    logo_banner: IOrganizationLogoBanner;
    logo_icon: IOrganizationLogoIcon;
    video: IOrganizationVideoID;
    theme_colour: IOrganizationColour;
    regioncount: IOrganizationRegionCount;
    usercount: IOrganizationUserCount;
    // updated_at: IOrganizationUpdatedAt
    waiver: IOrganizationWaiver;
    driver_help: IOrganizationDriverHelp;
    programs: IOrganizationPrograms;
    regions: IRegion[];
    show_route_widget_feed: IShowRouteWidgetFeed;
    embeddable_domain: IEmbeddableDomain;
    notification_signup_within_24_hours: INotificationSetting;
    notification_new_on_demand_route: INotificationSetting;
    notification_cancelled_on_demand_route_to_admin: INotificationSetting;
    notification_new_driver_signup: INotificationSetting;
    notification_cancelled_route_within_24_hours: INotificationSetting;
    notification_route_instance_comment: INotificationSetting;
    notification_no_show: INotificationSetting;
    notification_no_donations: INotificationSetting;
    notification_couldnt_make_it: INotificationSetting;
    notification_marketplace_recipient_claim: INotificationSetting;
    marketplace_enabled: IFeatureEnabled;
    marketplace_recipient_notifications_enabled?: INotificationSetting;
    approve_delivery_drivers: IApprovalRequired;
    approve_donors: IApprovalRequired;
    approve_recipients: IApprovalRequired;
    messaging_enabled: IFeatureEnabled;
    sharing_excess_enabled: IFeatureEnabled;
    recurring_route_signup_enabled: IFeatureEnabled;
    allow_donor_recipient_route_editing: IFeatureEnabled;
    delivery_driver_can_change_food_products: IDeliveryDriverCanChangeFoodProducts;
    delivery_driver_can_set_weight: IDeliveryDriverCanSetWeight;
}

export var defaultOrganization: IOrganization = {
    id: null,
    created_at: '',
    name: '',
    weight_unit: 'lb',
    distance_unit: 'km',
    temperature_unit: 'c',
    country: 'Canada',
    video: 'eTnY18Z70CY',
    logo_banner: '',
    logo_icon: '',
    theme_colour: '',
    regioncount: 0,
    usercount: 0,
    waiver: '',
    driver_help: '',
    programs: [],
    regions: [],
    show_route_widget_feed: false,
    embeddable_domain: '',
    notification_signup_within_24_hours: false,
    notification_new_on_demand_route: false,
    notification_cancelled_on_demand_route_to_admin: false,
    notification_new_driver_signup: false,
    notification_cancelled_route_within_24_hours: false,
    notification_route_instance_comment: false,
    notification_no_show: false,
    notification_no_donations: false,
    notification_couldnt_make_it: false,
    notification_marketplace_recipient_claim: false,
    marketplace_enabled: false,
    marketplace_recipient_notifications_enabled: false,
    messaging_enabled: false,
    sharing_excess_enabled: false,
    allow_donor_recipient_route_editing: false,
    recurring_route_signup_enabled: false,
    delivery_driver_can_change_food_products: false,
    delivery_driver_can_set_weight: false,
    approve_delivery_drivers: false,
    approve_donors: true,
    approve_recipients: true,
    
};
